if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"store","remotes":[{"alias":"zigzag-review","name":"zigzag-review","entry":"https://content.zigzag.kr/_review/latest/static/chunks/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(2(2366|5697|8611)|42(20|86)3|6(0233|0866|5689|9538|9941)|17454|30150|31136|55655|57077|94263|99794)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}